import { DeleteRule } from 'api/rules-endpoint';
import ConfirmButton from 'components/ConfirmButton';
import useOperationAuthorizationChecks from 'hooks/useOperationAuthorizationChecks';
import { getLinkToCreateRule } from 'navigator/links';
import { useNavigate } from 'react-router-dom';
import { useRulesContext } from 'stores/rules-context';
import { Rule } from 'types/rule';
import { UserOperations } from 'types/user';

interface DeleteRuleButtonProps {
  rule: Rule;
  className?: string;
  onDeleteFail: (message: string) => void;
}

function DeleteRuleButton({ rule, className, onDeleteFail }: DeleteRuleButtonProps): JSX.Element {
  const rulesContext = useRulesContext();
  const navigate = useNavigate();
  const canDeleteRule = useOperationAuthorizationChecks([UserOperations.RULE_DELETE]);

  if (!canDeleteRule) {
    return <></>;
  }

  const handleClick = async () => {
    const response = await DeleteRule(rule);
    if (response.success) {
      rulesContext.fetchData();
      navigate(getLinkToCreateRule());
    } else {
      onDeleteFail(response.message || '');
    }
  };

  return <ConfirmButton label='Delete Rule' onClick={handleClick} className={className} />;
}

DeleteRuleButton.defaultProps = {
  className: undefined,
};

export default DeleteRuleButton;
